module.exports = __webpack_public_path__ + "img/workout-notebook_B095QCT17H.87f49fee.jpg";